

export const Test = () => {
  
    return (
        <div className=" w-full flex flex-col">
          <a href='https://www.jajiga.com/' target="_blank">جاجیگا</a>
          <a href='https://www.alibaba.ir/' target="_blank">علی بابا</a>
          <a href='https://app.snapp.taxi/login' target="_blank">اسنپ</a>
          <a href='https://shipper.taraabar.net/home' target="_blank">ترابرنت</a>
        </div>
    )
}
